export default "__VITE_ASSET__Ubbu7pGM__"